export function getView(value) {
  return value ? 'Expanded' : 'Collapsed'
}
